export const blockIconsUiactionsArrowForwardNew = (
	<span className='material-symbols-outlined'>arrow_forward</span>
);
